/* eslint-disable react-hooks/exhaustive-deps */
// React
import React, { ChangeEvent, FC, useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import { AppDispatch } from "../../.."

// wijmo
import * as wjcCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjcGrid from "@grapecity/wijmo.react.grid"

import TextInput from "../../../components/InputWrapper/TextInput"
import util from "../../../ts/util"
import ComboBox from "../../../components/ComboBox"
import {
  clearAlert,
  setWarningAlerts,
  setAlerts,
} from "../../../globalStore/alertStore"
import { TApiResponse } from "../../../service/TApiResponse"
import { showMasterRegisterToast } from "../../../components/CustomToast"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"

import GRID from "../../../constant/flexGridConstant"
import RequiredMark from "../../../components/RequiredMark"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import TextArea from "../../../components/InputWrapper/TextAreaInput"
import { 区分マスタ } from "../../../service/master/kubun/TKubun"
import {
  TAyanasQueryPostReq,
  TAyanasQueryPutReq,
  TAyanasQueryRes,
  TAyanasQueryTablesGetRes,
  Tテーブル,
  Tフィルタ要素リストreq,
  Tフィールド,
  Tフィールドリストreq,
  T並び順リストreq,
} from "../../../service/ayanasQuery/TAyanasQuery"
import CheckBoxInput from "../../../components/InputWrapper/CheckBoxInput"
import AyanasQueryService from "../../../service/ayanasQuery/ayanasQueryService"
import {
  eフィルタ種別区分,
  eフィールド型区分,
  e並替条件区分,
  e接続条件区分,
  e比較演算子区分,
  Tフィールド型区分,
  T比較演算子区分,
} from "../../../constant/enum/ayanasQuery"
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons"
import dayjs from "dayjs"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import KubunService from "../../../service/master/kubun/kubunService"
import { 区分分類コード } from "../../../constant/enum/codes"

//#region[types]
type Tフィルタ条件DataGrid = Tフィルタ要素リストreq & {
  行ID: symbol
}
type T並替条件DataGrid = T並び順リストreq & {
  フィールドID?: number
  並び順ID?: number
  行ID: symbol
}
//#endregion

/**
 * ユーザマスタ登録
 * ユーザマスタ一覧から派生
 * @returns React.FC リアクトコンポーネント
 */
const QueryEditor: FC<{ tabChangeHandler: (tabIndex: number) => any }> = (
  props
) => {
  //#region [state]

  // ID取得
  const { queryId: id } = useParams<{ queryId: string }>()
  const is更新 = id ? true : false

  const history = useHistory()
  const location = useLocation()

  // Combo制御
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  const [テーブルItemSource, setテーブルItemSource] = useState<Tテーブル[]>()

  const [公開範囲ComboBox, set公開範囲ComboBox] = useState<TWijmoComboBox<
    string,
    区分マスタ
  > | null>(null)
  const [公開範囲isLoadEnded, set公開範囲isLoadEnded] = useState<boolean>(false)

  const [テーブルComboBox, setテーブルComboBox] = useState<TWijmoComboBox<
    number,
    TAyanasQueryTablesGetRes
  > | null>(null)
  const [テーブルisLoadEnded, setテーブルisLoadEnded] = useState<boolean>(false)

  const [initializedComboBoxData, setInitializedComboBoxData] = useState(false)

  // 設定条件
  const [クエリ名称, setクエリ名称] = useState<string>("")

  const [タグ, setタグ] = useState<string>("")

  const [説明, set説明] = useState("")
  const [公開範囲区分, set公開範囲区分] = useState<string | null>(null)

  const [テーブル, setテーブル] = useState<TAyanasQueryTablesGetRes | null>(
    null
  )
  const [テーブルID, setテーブルID] = useState<number | null>(null)

  const [削除フラグ, set削除フラグ] = useState(0)
  const [更新日時, set更新日時] = useState(new Date())

  const [フィールド一覧, setフィールド一覧] = useState<
    (Tフィールド & { name: string; value: number })[]
  >([])
  const [フィールドリスト, setフィールドリスト] = useState<number[]>([])
  const [フィールド一覧データマップ, setフィールド一覧データマップ] =
    useState<wjGrid.DataMap<number, string>>()
  // 更新押下時のフィールド一覧とテーブルビューの不整合を防ぐため　フィールド一覧側のテーブルIDを保持
  const [フィールド一覧用テーブルID, setフィールド一覧用テーブルID] = useState<
    number | null
  >(null)
  const [フィールド一覧用テーブル名称, setフィールド一覧用テーブル名称] =
    useState<string>("")

  // フィルター条件グリッド
  const [filterGrid, setFilterGrid] = useState<wjGrid.FlexGrid>()
  const [filterGridItemsSource, setFilterGridItemSource] =
    useState<wjcCore.CollectionView>()

  //フィルター条件グリッドの初期化時フラグ
  const [isInitFilterGrid, setIsInitFilterGrid] = useState(false)

  // 並び替え条件グリッド
  const [sortGrid, setSortGrid] = useState<wjGrid.FlexGrid>()
  const [sortGridItemsSource, setSortGridItemSource] =
    useState<wjcCore.CollectionView>()

  //フィルター条件グリッドの初期化時フラグ
  const [isInitSortGrid, setIsInitSortGrid] = useState(false)

  const [並替条件区分データマップ, set並替条件区分データマップ] =
    useState<wjGrid.DataMap<string, string>>()
  const [比較演算子区分リスト, set比較演算子区分リスト] = useState<
    区分マスタ[]
  >([])
  const ref比較演算子区分リスト = useRef<区分マスタ[]>([])
  const [比較演算子データマップ, set比較演算子データマップ] =
    useState<wjGrid.DataMap<string, string>>()

  // エラーメッセージ格納
  const [クエリ名称エラーメッセージ, setクエリ名称エラーメッセージ] =
    useState<string>("")

  const [タグエラーメッセージ, setタグエラーメッセージ] = useState<string>("")
  const [説明エラーメッセージ, set説明エラーメッセージ] = useState<string>("")
  const [Form外エラーメッセージList] = useState<string[]>([])

  const dispatch: AppDispatch = useDispatch()
  const [is初期表示, setIs初期表示] = useState<boolean>(true)
  //grid内エラー項目格納Array
  const [filterErrorCellPositionList] = useState<
    Array<{
      行ID: symbol
      colBinding: keyof Tフィルタ条件DataGrid
    }>
  >([])
  //grid内エラー項目格納Array
  const [sortErrorCellPositionList] = useState<
    Array<{
      行ID: symbol
      colBinding: keyof T並替条件DataGrid
    }>
  >([])

  // submit実行時エラー存在フラグ
  const [hasSubmitted, setHasSubmitted] = useState(false)

  // FormValidation用
  const refForm = useRef<HTMLFormElement>(null)

  // 確認モーダル用
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isSelectTableConfirmModalShow, setIsSelectTableConfirmModalShow] =
    useState(false)
  // 更新もしくは登録後、前に戻るかタブ遷移を行うかの設定
  const [isShowRunResult, setIsShowRunResult] = useState(false)

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(true)

  // フィールド全選択用チェックボックス
  const allFieldCheckBox = useRef<HTMLInputElement>(null)
  //#endregion

  //#region[method]

  /**
   * フィルタ条件用createCollectionView
   * @param data
   * @returns
   */
  const createFilterGridCollectionView = (data: Tフィルタ条件DataGrid[]) =>
    new wjcCore.CollectionView<Partial<Tフィルタ条件DataGrid>>(data, {
      newItemCreator() {
        return {
          行ID: Symbol(),
          フィールドID:
            フィールド一覧データマップ &&
            フィールド一覧データマップ.getKeyValues().length > 0
              ? フィールド一覧データマップ.getKeyValues()[0]
              : undefined,
          フィルタ種別区分: eフィルタ種別区分.WhereCondition,
          接続条件区分: e接続条件区分.AND,
          比較値1: "",
          比較値2: "",
          比較演算子区分: e比較演算子区分.Equal,
        } as Tフィルタ条件DataGrid
      },
    })

  const createSortGridCollectionView = (data: T並替条件DataGrid[]) =>
    new wjcCore.CollectionView<Partial<T並替条件DataGrid>>(data, {
      newItemCreator() {
        return {
          行ID: Symbol(),
          並替条件区分: e並替条件区分.ASC,
          フィールドID:
            フィールド一覧データマップ &&
            フィールド一覧データマップ.getKeyValues().length > 0
              ? フィールド一覧データマップ.getKeyValues()[0]
              : undefined,
        } as T並替条件DataGrid
      },
    })

  // グリッドの初期化
  const initFilterGrid = (grid: wjGrid.FlexGrid) => {
    grid.itemsSource = createFilterGridCollectionView([])

    setFilterGridItemSource(grid.itemsSource)

    setFilterGrid(grid)

    // 初回遷移時はフラグをOnにする
    if (isInitFilterGrid === false) setIsInitFilterGrid(true)
  }

  const initSortGrid = (grid: wjGrid.FlexGrid) => {
    grid.itemsSource = createSortGridCollectionView([])

    setSortGridItemSource(grid.itemsSource)
    setSortGrid(grid)

    // 初回遷移時はフラグをOnにする
    if (isInitSortGrid === false) setIsInitSortGrid(true)
  }

  const createPutQuery = (): TAyanasQueryPutReq => {
    // フィールド一覧より対象フィールドを選定
    const フィールドリストreqList: Tフィールドリストreq[] =
      フィールドリスト.map<Tフィールドリストreq>((f) => ({
        フィールドID: f,
      }))
    // フィルタ条件gridよりフィルタ条件リストを生成
    // フィルタ条件gridよりフィルタ条件リストを生成
    let フィルタ要素リスト: Tフィルタ要素リストreq[] = []
    const filterRows = filterGrid!.rows
    filterRows.forEach((r, i) => {
      if (r instanceof wjGrid._NewRowTemplate) return
      const data = r.dataItem as Tフィルタ条件DataGrid
      フィルタ要素リスト.push({
        ...data,
        並び順: i,
      })
    })
    // 並び替えgridより並び替え条件リストを生成
    let 並び順リスト: {
      並び順ID?: number
      フィールドID?: number
      並替条件区分: string
      並び順: number
    }[] = []
    const sortRows = sortGrid!.rows
    sortRows.forEach((r, i) => {
      if (r instanceof wjGrid._NewRowTemplate) return
      const data = r.dataItem as T並替条件DataGrid
      並び順リスト.push({
        ...data,
        並び順: i,
      })
    })

    return {
      クエリ名称,
      AQクエリID: parseInt(id),
      タグ,
      フィールドリスト: フィールドリストreqList,
      並び順リスト,
      テーブルID: テーブルID ?? 0, // nullは起こりえないがtypescriptの型チェック回避用に条件分岐する
      フィルタ要素リスト,
      公開範囲区分: 公開範囲区分 ?? "", // nullは起こりえないがtypescriptの型チェック回避用に条件分岐する
      更新日時,
      削除フラグ,
      説明,
    }
  }
  const createPostQuery = (): TAyanasQueryPostReq => {
    // フィールド一覧より対象フィールドを選定
    const フィールドリストreqList: Tフィールドリストreq[] =
      フィールドリスト.map<Tフィールドリストreq>((f) => ({
        フィールドID: f,
      }))
    // フィルタ条件gridよりフィルタ条件リストを生成
    let フィルタ要素リスト: Tフィルタ要素リストreq[] = []
    const filterRows = filterGrid!.rows
    filterRows.forEach((r, i) => {
      if (r instanceof wjGrid._NewRowTemplate) return
      const data = r.dataItem as Tフィルタ条件DataGrid
      フィルタ要素リスト.push({
        ...data,
        並び順: i,
      })
    })
    // 並び替えgridより並び替え条件リストを生成
    let 並び順リスト: T並び順リストreq[] = []
    const sortRows = sortGrid!.rows
    sortRows.forEach((r, i) => {
      if (r instanceof wjGrid._NewRowTemplate) return
      const data = r.dataItem as T並替条件DataGrid
      並び順リスト.push({
        ...data,
        並び順: i,
      })
    })

    return {
      クエリ名称,
      タグ,
      フィールドリスト: フィールドリストreqList,
      並び順リスト,
      テーブルID: テーブルID ?? 0, // nullは起こりえないがtypescriptの型チェック回避用に条件分岐する
      フィルタ要素リスト,
      公開範囲区分: 公開範囲区分 ?? "", // nullは起こりえないがtypescriptの型チェック回避用に条件分岐する
      説明,
    }
  }

  const beginningEdit = (s: wjGrid.FlexGrid, e: wjGrid.CellRangeEventArgs) => {
    var boundItem: Tフィルタ条件DataGrid = e.getRow().dataItem
    if (!boundItem) return

    const cellBinding = e.getColumn().binding as keyof Tフィルタ条件DataGrid

    // 比較値1と比較値2が入力不可の時にキャンセルされる
    const 比較演算子区分 = boundItem.比較演算子区分
    const 比較演算子 = ref比較演算子区分リスト.current.find(
      (d) => 比較演算子区分 === d.区分コード
    )

    switch (cellBinding) {
      case "比較値1":
        if (比較演算子 == null || 比較演算子.数値1 !== 1) {
          e.cancel = true
        }
        break
      case "比較値2":
        if (比較演算子 == null || 比較演算子.数値2 !== 1) {
          e.cancel = true
        }
        break
      default:
        break
    }
  }

  //TODO:色変えイベント
  // gridの必須チェックおよび検索イベント
  const filterGridFormatItemHandler = (
    f: wjGrid.FlexGrid,
    e: wjGrid.FormatItemEventArgs
  ) => {
    if (e.panel === f.cells) {
      const rowData: Tフィルタ条件DataGrid = e.getRow().dataItem
      const cellBinding = e.getColumn().binding as keyof Tフィルタ条件DataGrid
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        // エラー時色変えイベント
        setColorToErrorCell(f, e, filterErrorCellPositionList)
        // フィルタ比較演算子による比較値1,2のreadOnly処理
        let isReadOnly = false
        const 比較演算子区分 = rowData.比較演算子区分
        const 比較演算子 = ref比較演算子区分リスト.current.find(
          (d) => 比較演算子区分 === d.区分コード
        )

        switch (cellBinding) {
          case "比較値1":
            if (比較演算子 == null || 比較演算子.数値1 !== 1) {
              isReadOnly = true
              if (rowData.比較値1 != null) {
                const items = f.itemsSource as wjcCore.CollectionView<
                  Tフィルタ条件DataGrid[]
                >

                if (items.sourceCollection[e.row] != null) {
                  items.beginUpdate()
                  items.sourceCollection[e.row].比較値1 = undefined
                  items.endUpdate()
                  f.refresh()
                }
              }
            }
            wjcCore.toggleClass(e.cell, "read-only-cell", isReadOnly)
            break
          case "比較値2":
            if (比較演算子 == null || 比較演算子.数値2 !== 1) {
              isReadOnly = true
              if (rowData.比較値2 != null) {
                const items = f.itemsSource as wjcCore.CollectionView<
                  Tフィルタ条件DataGrid[]
                >

                if (items.sourceCollection[e.row] != null) {
                  items.beginUpdate()
                  items.sourceCollection[e.row].比較値2 = undefined
                  items.endUpdate()
                  f.refresh()
                }
              }
            }
            wjcCore.toggleClass(e.cell, "read-only-cell", isReadOnly)
            break

          default:
            break
        }
      }
    }
  }

  const sortGridFormatItemHandler = (
    f: wjGrid.FlexGrid,
    e: wjGrid.FormatItemEventArgs
  ) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        setColorToErrorCell(f, e, sortErrorCellPositionList)
      }
    }
  }

  const setColorToErrorCell = (
    f: wjGrid.FlexGrid,
    e: wjGrid.FormatItemEventArgs,
    list: Array<{
      行ID: symbol
      colBinding: keyof Tフィルタ条件DataGrid | keyof T並替条件DataGrid
    }>
  ) => {
    let isExistData = true
    const rowData: Object & { 行ID: Symbol } = e.getRow().dataItem
    const cellBinding = e.getColumn().binding
    if (rowData == null || rowData.行ID == null) return
    if (
      list.find((e) => e.colBinding === cellBinding && e.行ID === rowData.行ID)
    ) {
      isExistData = false
    }
    //TODO: なぜか色が出ないため保留
    wjcCore.toggleClass(e.cell, "not-exist-data-warning", !isExistData)
  }

  // テーブル変更時イベント
  const selectTable = async (tableId?: number, tableName?: string) => {
    let テーブルID
    let テーブル名 = tableName
    if (tableId == null && テーブル == null) return

    if (tableId != null) {
      テーブルID = tableId
    } else {
      if (テーブル == null) return
      テーブルID = テーブル.テーブルID
    }
    if (テーブル名 == null && テーブル != null) {
      テーブル名 = テーブル.テーブル論理名
    }
    try {
      const service = new AyanasQueryService()
      const res: TApiResponse<Tフィールド[]> = await service.getFields({
        テーブルID,
      })
      setフィールド一覧([
        ...res.data.map((a) => ({
          ...a,
          name: a.フィールド論理名,
          value: a.AQ_M_フィールドID,
        })),
      ])
      //grid用datamap更新
      const フィールドdataMap = new wjGrid.DataMap(
        res.data,
        "AQ_M_フィールドID",
        "フィールド論理名"
      )
      setフィールド一覧データマップ(フィールドdataMap)
      // 表示用およびバリデーションチェック用
      setフィールド一覧用テーブルID(テーブルID)
      setフィールド一覧用テーブル名称(テーブル名 ?? "")
      // フィルタ条件と並び替えのデータを消去する
      if (filterGrid) {
        filterGrid.itemsSource = createFilterGridCollectionView([])
        setFilterGridItemSource(filterGrid.itemsSource)
      }
      if (sortGrid) {
        sortGrid.itemsSource = createSortGridCollectionView([])
        setSortGridItemSource(sortGrid.itemsSource)
      }
      setフィールドリスト([])
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSelectTableConfirmModalShow(false)
    }
  }

  // データ取得
  const search = async (queryId = id) => {
    const service = new AyanasQueryService()

    try {
      const res: TApiResponse<TAyanasQueryRes> = await service.get(queryId)

      const クエリデータ = res.data
      // 上部設定
      setクエリ名称(クエリデータ.クエリ名称)
      set公開範囲区分(クエリデータ.公開範囲区分コード)
      setタグ(クエリデータ.タグ)
      setテーブルID(クエリデータ.AQ_M_テーブルID)
      set説明(クエリデータ.説明)
      // 隠し項目設定
      set更新日時(クエリデータ.更新日時)
      set削除フラグ(クエリデータ.削除フラグ)

      await selectTable(
        クエリデータ.AQ_M_テーブルID,
        クエリデータ.テーブル論理名
      )

      // テーブル設定が終わったことを確認し、フィールド一覧フィルタ条件並び替え条件を設定する。
      // フィルタ条件と並び替えのデータを消去する
      if (filterGrid) {
        filterGrid.itemsSource = createFilterGridCollectionView([
          ...クエリデータ.フィルタ要素リスト
            .sort((a, b) => a.ソート番号 - b.ソート番号)
            .map((a) => ({
              フィルタ要素ID: a.AQフィルタ要素ID,
              フィルタ種別区分: a.フィルタ種別区分コード,
              ソート番号: a.ソート番号,
              フィールドID: a.AQ_M_フィールドID,
              比較演算子区分: a.比較演算子区分コード,
              比較値1: a.値1,
              比較値2: a.値2,
              接続条件区分: a.接続条件区分コード,
              行ID: Symbol(),
            })),
        ])
        setFilterGridItemSource(filterGrid.itemsSource)
      }
      if (sortGrid) {
        sortGrid.itemsSource = createSortGridCollectionView([
          ...クエリデータ.並び順リスト
            .sort((a, b) => a.ソート番号 - b.ソート番号)
            .map((a) => ({
              並び順ID: a.並び順ID,
              フィールドID: a.フィールドID,
              並替条件区分: a.並替条件区分コード,
              並び順: a.ソート番号,
              行ID: Symbol(),
            })),
        ])
        setSortGridItemSource(sortGrid.itemsSource)
      }
      setフィールドリスト([
        ...クエリデータ.フィールドリスト.map((a) => a.AQ_M_フィールドID),
      ])
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  const allSelectToggle = (e: ChangeEvent<HTMLInputElement>) => {
    // チェック時に全選択チェック解除にすべて外す
    if (e.target.checked) {
      if (フィールドリスト.length === フィールド一覧.length) return
      setフィールドリスト(フィールド一覧.map((f) => f.value))
    } else {
      setフィールドリスト([])
    }
  }
  //#endregion

  //#region [effect]

  useEffect(() => {
    // 区分とテーブル情報を取得
    Promise.all([
      new KubunService().getList(),
      new AyanasQueryService().getTables({}),
    ]).then(([kubunRes, tableRes]) => {
      set区分ItemSource([...kubunRes.data])
      setテーブルItemSource([...tableRes.data])
      // 区分をdataMapに入れる
      const 比較演算子区分List = kubunRes.data.filter(
        (d) => d.分類コード === 区分分類コード.AyanasQuery.比較演算子区分
      )
      const 比較演算子dataMap = new wjGrid.DataMap(
        比較演算子区分List,
        "区分コード",
        "名称2"
      )
      ref比較演算子区分リスト.current.splice(
        0,
        ref比較演算子区分リスト.current.length,
        ...比較演算子区分List
      )
      set比較演算子区分リスト(比較演算子区分List)
      set比較演算子データマップ(比較演算子dataMap)

      set並替条件区分データマップ(
        new wjGrid.DataMap(
          kubunRes.data.filter(
            (d) => d.分類コード === 区分分類コード.AyanasQuery.並替条件区分
          ),
          "区分コード",
          "名称2"
        )
      )
      setInitializedComboBoxData(true)
    })
  }, [])

  // 初期データ設定用
  useEffect(() => {
    if (is初期表示 !== true) {
      return
    }
    if (
      !isInitFilterGrid ||
      !isInitSortGrid ||
      公開範囲ComboBox == null ||
      テーブルComboBox == null ||
      !initializedComboBoxData
    ) {
      return
    }

    // URLパラメタにIDがある場合データを表示
    if (id) {
      search()
    } else {
      selectTable()
    }

    setIs初期表示(false)
  }, [
    isInitFilterGrid,
    isInitSortGrid,
    公開範囲ComboBox,
    テーブルComboBox,
    initializedComboBoxData,
  ])

  useEffect(() => {
    if (
      hasSubmitted &&
      [
        クエリ名称エラーメッセージ,
        タグエラーメッセージ,
        説明エラーメッセージ,
        ...Form外エラーメッセージList,
      ].find((e) => e !== "")
    ) {
      dispatch(
        setWarningAlerts([
          クエリ名称エラーメッセージ,
          タグエラーメッセージ,
          説明エラーメッセージ,
          ...Form外エラーメッセージList,
        ])
      )
      // メッセージを見せるためスクロールをトップに移動
      util.goToPageTop()
      filterGrid?.refresh()
    }
    setHasSubmitted(false)
  }, [hasSubmitted])

  // テーブルcombobox変更時に裏で持っているテーブル情報を更新
  useEffect(() => {
    if (!テーブルItemSource) return
    if (テーブルID) {
      setテーブル(
        テーブルItemSource.find((t) => t.テーブルID === テーブルID) ?? null
      )
    } else {
      setテーブル(null)
    }
  }, [テーブルID])

  //#endregion

  //#region [submitMethod]
  const beforeSubmit = (e: any) => {
    if (!isValidationCheckBeforeSubmit()) return
    setIsConfirmModalShow(true)
  }

  // 登録ボタン
  const submit = async (e: any) => {
    // MEMO:入力チェックで値が設定されている事を担保. tsチェック回避用
    /*
    if (タグ == null || 公開範囲区分 == null) {
      return
    }
    */
    isPrompt.current = false
    try {
      // idが存在すれば更新、なければ登録
      const service = new AyanasQueryService()

      let res: TApiResponse<TAyanasQueryRes>
      let toastComment = ""
      if (id) {
        // // 更新
        res = await service.put(id, createPutQuery())
        toastComment = `クエリ更新しました: ${res.data.クエリ名称}`
      } else {
        // 登録
        res = await service.post(createPostQuery())
        toastComment = `クエリを登録しました: ${res.data.クエリ名称}`
      }
      dispatch(setAlerts(res))
      showMasterRegisterToast(toastComment)
      if (isShowRunResult) {
        if (id == null) {
          history.replace(`${location.pathname}/${res.data.AQクエリID}`)
        }
        search(res.data.AQクエリID.toString())
        props.tabChangeHandler(1)
        //history.goBack()
      } else {
        history.goBack()
      }
    } catch (err) {
      //errorメッセージ表示
      dispatch(setAlerts(err))
      // メッセージを見せるためスクロールをトップに移動
      util.goToPageTop()
      isPrompt.current = true
    } finally {
      setIsConfirmModalShow(false)
    }
  }
  //#endregion

  // 登録前のバリデーションチェック（必須あれば各動作実装する）
  //#region [validation]
  const isValidationCheckBeforeSubmit = (): boolean => {
    // アラートの解除
    dispatch(clearAlert())
    setクエリ名称エラーメッセージ("")
    setタグエラーメッセージ("")
    set説明エラーメッセージ("")
    filterErrorCellPositionList.splice(0, filterErrorCellPositionList.length)
    sortErrorCellPositionList.splice(0, sortErrorCellPositionList.length)
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    let hasError = false
    let messages: Array<string> = []

    if (refForm != null && refForm.current) {
      // 上部のチェック
      const form = refForm.current
      if (!form.checkValidity()) {
        hasError = true
      }
      // フィールド一覧
      // テーブル・ビューの選択されているテーブルとフィールド一覧のテーブルが違う場合エラー
      if (テーブルID !== フィールド一覧用テーブルID) {
        messages.push(
          `選択されているテーブルとフィールド一覧のテーブルが一致していません。`
        )
        hasError = true
      }
      // 一件も選択されていない時にエラー
      if (フィールドリスト.length <= 0) {
        messages.push(`表示フィールドは１つ以上選択して下さい。`)
        hasError = true
      }

      // フィルタ条件grid

      if (filterGrid == null) {
        messages.push(`フィルタ条件 のデータが読み取れません`)
        hasError = true
      } else {
        // 必須チェック
        let isRequiredError = false
        let isDateStringError = false
        let isNumberStringError = false

        filterGrid.rows.forEach((gridRow) => {
          if (gridRow instanceof wjGrid._NewRowTemplate) return
          const rowData = gridRow.dataItem as Tフィルタ条件DataGrid
          console.log(rowData)
          if (rowData.フィールドID == null) {
            // フィールド名 必須チェック
            filterErrorCellPositionList.push({
              行ID: rowData.行ID,
              colBinding: "フィールドID",
            })
            isRequiredError = true
          }
          // 比較演算子 必須チェック
          if (rowData.比較演算子区分 == null) {
            filterErrorCellPositionList.push({
              行ID: rowData.行ID,
              colBinding: "比較演算子区分",
            })
            isRequiredError = true
          } else {
            //比較値のチェック
            const 比較演算子区分 = rowData.比較演算子区分
            const 比較演算子 = ref比較演算子区分リスト.current.find(
              (d) => 比較演算子区分 === d.区分コード
            )
            if (比較演算子) {
              // 比較値の型チェックのため、フィールド一覧より型を取得
              let 対象フィールド
              if (rowData.フィールドID != null) {
                対象フィールド = フィールド一覧.find(
                  (field) => field.AQ_M_フィールドID === rowData.フィールドID
                )
              }
              // 数値1
              if (比較演算子.数値1 === 1) {
                let 数値1hasError = false
                // 必須チェック
                if (
                  rowData.比較値1 == null ||
                  wjcCore.isNullOrWhiteSpace(rowData.比較値1)
                ) {
                  isRequiredError = true
                  数値1hasError = true
                }
                // 型チェック
                if (対象フィールド) {
                  switch (
                    対象フィールド.フィールド型区分コード as Tフィールド型区分
                  ) {
                    case eフィールド型区分.Date:
                      // dayjsを用いて変換し、変換できなかった場合エラー
                      const isStringToDate =
                        rowData.比較値1 == null
                          ? false
                          : dayjs(new Date(rowData.比較値1)).isValid()
                      if (!isStringToDate) {
                        isDateStringError = true
                        数値1hasError = true
                      }

                      break
                    case eフィールド型区分.Number:
                      const isStringToNumber =
                        rowData.比較値1 == null
                          ? false
                          : isNaN(+rowData.比較値1)
                      if (isStringToNumber) {
                        isNumberStringError = true
                        数値1hasError = true
                      }
                      break
                    default:
                      break
                  }
                }
                if (数値1hasError) {
                  filterErrorCellPositionList.push({
                    行ID: rowData.行ID,
                    colBinding: "比較値1",
                  })
                }
              }

              // 数値2
              if (比較演算子.数値2 === 1) {
                let 数値2hasError = false
                // 必須チェック
                if (
                  rowData.比較値2 == null ||
                  wjcCore.isNullOrWhiteSpace(rowData.比較値2)
                ) {
                  isRequiredError = true
                  数値2hasError = true
                }
                // 型チェック
                if (対象フィールド) {
                  switch (
                    対象フィールド.フィールド型区分コード as Tフィールド型区分
                  ) {
                    case eフィールド型区分.Date:
                      // dayjsを用いて変換し、変換できなかった場合エラー
                      const isStringToDate = dayjs(rowData.比較値2).isValid()
                      if (!isStringToDate) {
                        isDateStringError = true
                        数値2hasError = true
                      }

                      break
                    case eフィールド型区分.Number:
                      const isStringToNumber =
                        rowData.比較値2 == null
                          ? false
                          : isNaN(+rowData.比較値2)
                      if (isStringToNumber) {
                        isNumberStringError = true
                        数値2hasError = true
                      }
                      break
                    default:
                      break
                  }
                }
                if (数値2hasError) {
                  filterErrorCellPositionList.push({
                    行ID: rowData.行ID,
                    colBinding: "比較値2",
                  })
                }
              }
            }
          }
        })
        if (isNumberStringError) {
          messages.push(
            `フィルタ条件 で数値入力の項目に数値が入っていないセルが存在します。`
          )
          hasError = true
        }
        if (isDateStringError) {
          messages.push(
            `フィルタ条件 で日付入力の項目に日付が入っていないセルが存在します。（入力例: 2021/01/01 00:00:00）`
          )
          hasError = true
        }
        if (isRequiredError) {
          messages.push(
            `フィルタ条件 に必須項目が入力されていない条件が存在します`
          )
          hasError = true
        }
      }

      if (sortGrid == null) {
        messages.push(`並び替え のデータが読み取れません`)
        hasError = true
      } else {
        // 必須チェック
        let isRequiredError = false

        sortGrid.rows.forEach((gridRow) => {
          if (gridRow instanceof wjGrid._NewRowTemplate) return
          const rowData = gridRow.dataItem as T並替条件DataGrid
          console.log(rowData)
          if (rowData.フィールドID == null) {
            // フィールド名 必須チェック
            sortErrorCellPositionList.push({
              行ID: rowData.行ID,
              colBinding: "フィールドID",
            })
            isRequiredError = true
          }
        })
        if (isRequiredError) {
          messages.push(`並び替え に必須項目が入力されていない条件が存在します`)
          hasError = true
        }
      }
    } else {
      //formが見当たらない場合
      messages.push(
        `入力項目が確認できませんでした。ページをリロードしてください。`
      )
      hasError = true
    }
    if (hasError) {
      Form外エラーメッセージList.push(...messages)
      setHasSubmitted(hasError)
    }
    filterGrid?.refresh()
    return !hasError
  }
  //#endregion

  return (
    <>
      {/* <Prompt when={isPrompt.current} message={BROWSER_BACK_MESSAGE}></Prompt> */}
      <form ref={refForm} noValidate={true}>
        <Container fluid>
          <Row className="mt-4 w-110rem">
            <Col>
              <Card>
                <Card.Body>
                  <Container fluid>
                    <Row>
                      <Col xs={6}>
                        <Container fluid className="info-form">
                          <div className="info-form-row">
                            {/* クエリ名 text */}
                            <div className="info-form-item">
                              <div className="info-form-label w-10rem">
                                <label htmlFor="クエリ名">
                                  クエリ名
                                  <RequiredMark />
                                </label>
                              </div>
                              <div className="info-form-value w-40rem">
                                <TextInput
                                  name="クエリ名"
                                  id="クエリ名"
                                  isRequired
                                  autoFocus
                                  maxLength={30}
                                  value={クエリ名称}
                                  setValue={setクエリ名称}
                                  setInvalidMessage={(s: string) =>
                                    setクエリ名称エラーメッセージ(s)
                                  }
                                  size={60}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="info-form-row">
                            {/* 公開範囲 text */}
                            <div className="info-form-item">
                              <div className="info-form-label w-10rem">
                                <label htmlFor="公開範囲">
                                  公開範囲
                                  <RequiredMark />
                                </label>
                              </div>
                              <div className="info-form-value w-20rem">
                                <ComboBox.Kubun
                                  分類コード={
                                    区分分類コード.AyanasQuery.公開範囲区分
                                  }
                                  // placeholder="公開範囲"
                                  isAllSelect={false}
                                  isRequired={true}
                                  ComboBox={公開範囲ComboBox}
                                  setComboBox={set公開範囲ComboBox}
                                  isLoadEnded={公開範囲isLoadEnded}
                                  setIsLoadEnded={set公開範囲isLoadEnded}
                                  itemsSource={区分ItemSource}
                                  selectedValue={公開範囲区分}
                                  setSelectedValue={
                                    set公開範囲区分
                                  }></ComboBox.Kubun>
                              </div>
                            </div>
                          </div>
                          <div className="info-form-row">
                            {/* タグ text */}
                            <div className="info-form-item">
                              <div className="info-form-label w-10rem">
                                <label htmlFor="タグ">タグ</label>
                              </div>
                              <div className="info-form-value w-25rem">
                                <TextInput
                                  name="タグ"
                                  maxLength={20}
                                  id="タグ"
                                  value={タグ}
                                  setValue={setタグ}
                                  setInvalidMessage={setタグエラーメッセージ}
                                  size={40}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="info-form-row">
                            {/* テーブル・ビュー text */}
                            <div className="info-form-item">
                              <div className="info-form-label w-10rem">
                                <label htmlFor="テーブル・ビュー">
                                  テーブル・ビュー
                                  <RequiredMark />
                                </label>
                              </div>
                              <div className="info-form-value w-20rem">
                                <ComboBox.AQTable
                                  // placeholder="テーブル・ビュー"
                                  isRequired={true}
                                  selectedValue={テーブルID}
                                  setSelectedValue={setテーブルID}
                                  ComboBox={テーブルComboBox}
                                  setComboBox={setテーブルComboBox}
                                  isLoadEnded={テーブルisLoadEnded}
                                  setIsLoadEnded={setテーブルisLoadEnded}
                                  itemsSource={
                                    テーブルItemSource
                                  }></ComboBox.AQTable>
                                <Button
                                  style={{ marginLeft: "2rem" }}
                                  onClick={() => {
                                    setIsSelectTableConfirmModalShow(true)
                                  }}>
                                  選択
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Container>
                      </Col>
                      <Col xs={6}>
                        <Container fluid className="info-form">
                          <div className="info-form-row">
                            {/* ユーザーコード text */}
                            <div className="info-form-item">
                              <div className="info-form-label w-10rem">
                                <label htmlFor="クエリの説明">
                                  クエリの説明
                                </label>
                              </div>
                              <div className="info-form-value w-40rem">
                                <TextArea
                                  name="クエリの説明"
                                  id="クエリの説明"
                                  cols={60}
                                  rows={8}
                                  maxLength={2000}
                                  value={説明}
                                  setValue={set説明}
                                  setInvalidMessage={set説明エラーメッセージ}
                                />
                              </div>
                            </div>
                          </div>
                        </Container>
                      </Col>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* グリッド START */}
          <Row className="w-110rem">
            <Col xs={3} className="min-w-10rem">
              <Card>
                <Card.Header>
                  <Form.Check
                    type="checkbox"
                    onChange={allSelectToggle}
                    label={`表示フィールド一覧: ${フィールド一覧用テーブル名称}`}
                    checked={フィールドリスト.length === フィールド一覧.length}
                    ref={allFieldCheckBox}
                  />
                </Card.Header>
                <Card.Body
                  style={{
                    minHeight: "40rem",
                    maxHeight: "40rem",
                    overflowY: "auto",
                  }}>
                  <CheckBoxInput
                    isVertical
                    setSelectedValue={setフィールドリスト}
                    selectedValue={フィールドリスト}
                    onChange={(e, newValues) => {
                      if (
                        allFieldCheckBox == null ||
                        allFieldCheckBox.current == null
                      )
                        return
                      if (newValues.length === フィールド一覧.length) {
                        allFieldCheckBox.current.checked = true
                      } else {
                        allFieldCheckBox.current.checked = false
                      }
                    }}
                    checkBoxBtnList={フィールド一覧}></CheckBoxInput>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              {/* フィルタ条件 */}
              <Card>
                <Card.Header>フィルタ条件</Card.Header>
                <Card.Body>
                  <wjcGrid.FlexGrid
                    {...GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                    allowSorting={wjGrid.AllowSorting.None}
                    allowDragging={wjGrid.AllowDragging.Both}
                    style={{ minHeight: "15rem", maxHeight: "15rem" }}
                    initialized={initFilterGrid}
                    formatItem={filterGridFormatItemHandler}>
                    <wjcGrid.FlexGridColumn
                      binding="フィールドID"
                      header="フィールド名"
                      isRequired={true}
                      width={120}
                      dataMap={フィールド一覧データマップ}>
                      <wjcGrid.FlexGridCellTemplate
                        cellType="ColumnHeader"
                        template={() => {
                          return (
                            <>
                              <span>フィールド名</span>
                              <RequiredMark />
                            </>
                          )
                        }}></wjcGrid.FlexGridCellTemplate>
                    </wjcGrid.FlexGridColumn>
                    <wjcGrid.FlexGridColumn
                      binding="比較演算子区分"
                      header="フィルタ"
                      isRequired={true}
                      width={120}
                      dataMap={比較演算子データマップ}>
                      <wjcGrid.FlexGridCellTemplate
                        cellType={wjcGrid.CellTemplateType.ColumnHeader}
                        template={() => {
                          return (
                            <>
                              <span>フィルタ</span>
                              <RequiredMark />
                            </>
                          )
                        }}></wjcGrid.FlexGridCellTemplate>
                    </wjcGrid.FlexGridColumn>
                    <wjcGrid.FlexGridColumn
                      binding="比較演算子区分"
                      header="記号"
                      isRequired={true}
                      isReadOnly={true}
                      cssClass="read-only-cell"
                      width={100}>
                      <wjcGrid.FlexGridCellTemplate
                        cellType={wjcGrid.CellTemplateType.Cell}
                        template={(
                          context: TWijmoCellTemplateContext<Tフィルタ条件DataGrid>
                        ) => {
                          const 比較演算子区分 = context.item
                            .比較演算子区分 as T比較演算子区分
                          let 比較演算子記号 = ""
                          if (比較演算子区分リスト != null) {
                            const 比較演算子 = 比較演算子区分リスト.find(
                              (a) => a.区分コード === 比較演算子区分
                            )
                            if (比較演算子 != null) {
                              比較演算子記号 = 比較演算子.名称3
                            }
                          }
                          return (
                            <>
                              <span>{比較演算子記号}</span>
                            </>
                          )
                        }}></wjcGrid.FlexGridCellTemplate>
                    </wjcGrid.FlexGridColumn>
                    <wjcGrid.FlexGridColumn
                      binding="比較値1"
                      header="比較値1"
                      maxLength={1000}
                      width={120}></wjcGrid.FlexGridColumn>
                    <wjcGrid.FlexGridColumn
                      binding="比較値2"
                      header="比較値2"
                      maxLength={1000}
                      width={120}></wjcGrid.FlexGridColumn>
                    <wjcGrid.FlexGridColumn
                      header="　"
                      align="center"
                      width={120}
                      allowResizing={false}
                      isReadOnly>
                      <wjcGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: any) => {
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              style={{
                                marginLeft: "0.5rem",
                                marginRight: "0.5rem",
                              }}
                              variant="caution"
                              onClick={(e) => {
                                e.preventDefault()
                                if (filterGridItemsSource === undefined) return
                                filterGridItemsSource.removeAt(
                                  context.row.index
                                )
                                //エラーリストより削除
                                const filtered =
                                  filterErrorCellPositionList.filter(
                                    (d) => d.行ID !== context.row.dataItem.行ID
                                  )
                                const length =
                                  filterErrorCellPositionList.length
                                for (let i = 0; i < length; i++) {
                                  filterErrorCellPositionList.shift()
                                }
                                filterErrorCellPositionList.push(...filtered)

                                setFilterGridItemSource(filterGridItemsSource)
                                filterGrid?.refresh()
                              }}>
                              <FontAwesomeIcon icon={faTrashAlt} />
                              <span>削除</span>
                            </Button>
                          )
                        }}
                      />
                    </wjcGrid.FlexGridColumn>
                  </wjcGrid.FlexGrid>
                </Card.Body>
              </Card>
              {/* 並び替え */}
              <Card>
                <Card.Header>並び替え</Card.Header>
                <Card.Body>
                  <wjcGrid.FlexGrid
                    {...GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                    style={{ minHeight: "15rem", maxHeight: "15rem" }}
                    allowDragging={wjGrid.AllowDragging.Both}
                    allowSorting={wjGrid.AllowSorting.None}
                    initialized={initSortGrid}
                    beginningEdit={beginningEdit}
                    formatItem={sortGridFormatItemHandler}>
                    <wjcGrid.FlexGridColumn
                      binding="フィールドID"
                      header="フィールド名"
                      isRequired={true}
                      width={120}
                      dataMap={フィールド一覧データマップ}>
                      <wjcGrid.FlexGridCellTemplate
                        cellType={wjcGrid.CellTemplateType.ColumnHeader}
                        template={() => {
                          return (
                            <>
                              <span>フィールド名</span>
                              <RequiredMark />
                            </>
                          )
                        }}></wjcGrid.FlexGridCellTemplate>
                    </wjcGrid.FlexGridColumn>
                    <wjcGrid.FlexGridColumn
                      binding="並替条件区分"
                      header="フィルタ"
                      isRequired={true}
                      width={120}
                      dataMap={並替条件区分データマップ}>
                      <wjcGrid.FlexGridCellTemplate
                        cellType={wjcGrid.CellTemplateType.ColumnHeader}
                        template={() => {
                          return (
                            <>
                              <span>フィルタ</span>
                              <RequiredMark />
                            </>
                          )
                        }}></wjcGrid.FlexGridCellTemplate>
                    </wjcGrid.FlexGridColumn>
                    <wjcGrid.FlexGridColumn
                      header="　"
                      align="center"
                      width={120}
                      allowResizing={false}
                      isReadOnly>
                      <wjcGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: any) => {
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              style={{
                                marginLeft: "0.5rem",
                                marginRight: "0.5rem",
                              }}
                              variant="caution"
                              onClick={(e) => {
                                e.preventDefault()
                                if (sortGridItemsSource === undefined) return
                                sortGridItemsSource.removeAt(context.row.index)
                                //エラーリストより削除
                                const filtered =
                                  filterErrorCellPositionList.filter(
                                    (d) => d.行ID !== context.row.dataItem.行ID
                                  )
                                const length =
                                  filterErrorCellPositionList.length
                                for (let i = 0; i < length; i++) {
                                  filterErrorCellPositionList.shift()
                                }
                                filterErrorCellPositionList.push(...filtered)

                                setSortGridItemSource(sortGridItemsSource)
                              }}>
                              <FontAwesomeIcon icon={faTrashAlt} />
                              <span>削除</span>
                            </Button>
                          )
                        }}
                      />
                    </wjcGrid.FlexGridColumn>
                  </wjcGrid.FlexGrid>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {/* グリッド END */}
          <Row className="search-button mb-3">
            <Col xl={{ span: "auto", offset: 0 }}>
              <Button
                type="submit"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setIsShowRunResult(false)
                  beforeSubmit(e)
                }}>
                {id ? `更新` : `登録`}
              </Button>
            </Col>
            <Col xl={{ span: "auto", offset: 0 }}>
              <Button
                type="submit"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setIsShowRunResult(true)
                  beforeSubmit(e)
                }}>
                {id ? `更新して実行` : `登録して実行`}
              </Button>
            </Col>
            <Col>
              <Button
                type="button"
                variant="secondary"
                onClick={(e) => {
                  history.goBack()
                }}>
                一覧に戻る
              </Button>
            </Col>
          </Row>
        </Container>
      </form>
      <ConfirmModal
        isShow={isSelectTableConfirmModalShow}
        hideHandler={setIsSelectTableConfirmModalShow}
        submitHandler={() => {
          selectTable()
        }}>
        選択したテーブルに変更するため、出力条件が初期化されます。よろしいですか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{is更新 ? "更新" : "登録"}しますか？
      </ConfirmModal>
    </>
  )
}

export default QueryEditor
